<template>
	<div class="searchbox cursorstyle">
		<div class="search_leftbox stylePointer">
			<!-- 请输入关键词，例如产权名称、产权代码等 -->
			<el-autocomplete v-model="state" :fetch-suggestions="querySearchAsync" placeholder="请输入内容"
				 :trigger-on-focus="false" @select="handleSelect"></el-autocomplete>

		</div>
		<div class="search_rightbox stylePointer" @click="searchBtn()">搜索</div>
	</div>
</template>

<script>
	// 转化列表
	import {
		auditList
	} from "@/api/home.js"
	export default {

		data() {
			return {
				restaurants: [],
				state: '',
				timeout: null
			}
		},
		mounted() {
			// this.achievementLists(1)
		},
		methods: {
			searchBtn(){
				this.$router.push({path:'/achievementListMorePage',query:{val:this.state}})
			},
			// 处理数据
			async achievementLists(data, data1, cb, queryString) {
				let obj = {
					name: ''
				}
				let res = await auditList(obj)
				if (res.code == '00000') {
					let arr = []
					res.data.result.map((item, index) => {
						if (item.name != '' && item.name != ' ' && item.name != null) {
							arr.push({
								value: item.name
							})
						} else {
							// console.log('我没有名字')
						}
					})
					this.restaurants = arr
					var restaurants = this.restaurants;
					var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
					// 调用 callback 返回建议列表的数据
					cb(results);

				}
			},

			querySearchAsync(queryString, cb) {

				// var restaurants = this.restaurants;
				// var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

				// clearTimeout(this.timeout);
				// this.timeout = setTimeout(() => {
				// 	cb(results);
				// }, 3000 * Math.random());
				var data = {}
				data.name = queryString;
				// 请求接口
				this.achievementLists(data, data, cb, queryString)



			},
			createStateFilter(queryString) {
				console.log(queryString)
				return (state) => {
					return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
				};
			},
			handleSelect(item) {
				this.state = item.value
			}
		}

	}
</script>

<style scoped="scoped" lang="less">
	.searchbox {
		width: 39vw;
    height: 3.1vw;

    //margin-top: 14px;
		// margin-left: 28px;
		display: flex;
	}

	.search_leftbox {
		width: 33vw;
		line-height: 3.1vw;
		color: rgba(151, 144, 144, 0.58);
		font-size: 1rem;
		background: #ffffff;
		padding-left: 13px;
		border-radius: 5px 0px 0px 5px;
	}

	.search_rightbox {
		width: 5.6vw;
    height: 3.1vw;

    background: #D96025;
		border-radius: 0px 5px 5px 0px;
		text-align: center;
		line-height: 3.1vw;
		font-size: 1.12rem;
		color: #ffffff;
	}
	/deep/.el-autocomplete {
	    width: 100%;
	    height: 100%;
	    position: relative;
	    display: inline-block;
	}
	/deep/.el-input__inner {
	    -webkit-appearance: none;
	    background-color: #FFF;
	    background-image: none;
	    border: none;
	    box-sizing: border-box;
	    color: #606266;
	    display: inline-block;
	    font-size: inherit;
	    height: 100%;
	    line-height: 49px;
	    outline: 0;
	    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
	    width: 100%;
	}
	
	
</style>
